import { TemplateEngine } from "../../utils/TemplateEngine.js";
import { SesionService } from "../../services/SesionService.js";
import { AppConfig } from "../../utils/AppConfig.js";
import { FotoPerfil } from "../FotoPerfil.js";
import navbarTemplate from "./navbar.html?raw";

// Layout comun: navbar arriba, contenido de la pantalla, footer con version.
// Los controllers hacen: Layout.render(contenidoHtml) y despues bindean sus eventos.
export const Layout = {
  render(contenido) {
    const emp = SesionService.empleado();
    const navbar = TemplateEngine.render(navbarTemplate, {
      conSesion: !!emp,
      avatar: emp ? FotoPerfil.avatarHtml("avatar-sm") : "",
    });

    const footer =
      '<footer class="app-footer text-center text-muted small py-3">' +
      "Sistemas &middot; v" + TemplateEngine.escapeHtml(AppConfig.app.version) +
      "</footer>";

    document.getElementById("app").innerHTML =
      navbar + '<main class="app-main">' + contenido + "</main>" + footer;

    document.getElementById("btnFotoPerfil")?.addEventListener("click", (e) => {
      e.preventDefault();
      FotoPerfil.abrir();
    });

    document.getElementById("btnSalir")?.addEventListener("click", (e) => {
      e.preventDefault();
      SesionService.cerrar();
      window.location.hash = "acceso";
    });
  },

  /** Pantalla de error tecnico dentro del layout, con boton para reintentar. */
  renderError(onReintentar) {
    Layout.render(
      '<div class="container py-5">' +
      '<div class="card shadow-sm mx-auto" style="max-width:520px">' +
      '<div class="card-body text-center p-4">' +
      '<i class="fas fa-triangle-exclamation fa-3x text-warning mb-3"></i>' +
      '<h4 class="card-title">Ups, hubo un error</h4>' +
      '<p class="text-muted">Intentá de nuevo en unos minutos. Si seguís viendo esta pantalla, avisale a Sistemas.</p>' +
      '<button id="btnReintentar" class="btn btn-primary"><i class="fas fa-rotate me-1"></i>Reintentar</button>' +
      "</div></div></div>"
    );
    document.getElementById("btnReintentar")?.addEventListener("click", onReintentar);
  },
};
